<template>
  <TemplateBase :page="page">
    <!-- Slot with back button with flush false so it is positioned to the header -->
    <template #backButton>
      <MoleculeButtonBreadcrumbBack :breadcrumbs="breadcrumbs" />
    </template>

    <div class="grid grid-cols-12 bg-white sm:bg-transparent">
      <section v-if="page.image" class="col-span-full row-start-1 bg-white sm:bg-transparent z-0 v-margin-page-image-to-page-content">
        <MoleculeMaskVisual :image="page.image" />
      </section>

      <OrganismPageSectionContent
        class="row-start-2 col-span-full mb-8 md:mb-12"
        :at-page-top="!page.image"
        :title="page.title"
        :subtitle="page.subtitle"
        :introduction="page.introduction"
        :description="page.description"
        :date="new Date(page.postDate)"
      />

      <MoleculeMatrix class="row-start-3 col-span-full" :items="page.dynamicContent" />
    </div>
  </TemplateBase>
</template>

<script setup lang="ts">
defineProps({
  breadcrumbs: { type: Array as PropType<any[]>, required: true },
  page: { type: Object as PropType<Record<string, any>>, required: true },
})
</script>
